module.exports = highlight.js;